/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementsSearch} from '../models/EntitlementsSearch';
import type {Error} from '../models/Error';
import type {ResourceType} from '../models/ResourceType';
import type {SortDirection} from '../models/SortDirection';

export interface SearchEntitlements$Request {
    pageNumber: number;
    pageSize: number;
    sortDirection: SortDirection;
    excludedResourceTypes?: Array<ResourceType>;
    requestBody?: Array<string>;
}

export interface SearchEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchEntitlementsRequest = createAction<PayloadData<void, SearchEntitlements$Request>>('ENTITLEMENTS_SEARCH__SEARCH_ENTITLEMENTS__REQUEST');
export const searchEntitlementsSuccess = createAction<PayloadData<EntitlementsSearch, SearchEntitlements$Request>>('ENTITLEMENTS_SEARCH__SEARCH_ENTITLEMENTS__SUCCESS');
export const searchEntitlementsFailure = createAction<PayloadData<Error, SearchEntitlements$Request, true>>('ENTITLEMENTS_SEARCH__SEARCH_ENTITLEMENTS__FAILURE');

export const searchEntitlementsActions = [
    searchEntitlementsRequest,
    searchEntitlementsSuccess,
    searchEntitlementsFailure
] as const;

/**
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {SortDirection} meta.sortDirection
 * @param {Array<ResourceType>} [meta.excludedResourceTypes]
 * @param {Array<string>} [meta.requestBody]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchEntitlements = (meta: SearchEntitlements$Request, config?: SearchEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
        sortDirection: meta.sortDirection,
        excludedResourceTypes: meta.excludedResourceTypes,
    };
    return {
        CALL_API: {
            types: searchEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/search`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

